<div class="modal-header bg-dark text-center">
    <h4 class="modal-title">Creazione Nuovo <strong>Segnalatore</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body" style="margin-bottom: 10px;">
    <div *ngIf="formError" class="alert alert-danger" role="alert">{{ formError }}</div>
    <p class="section-title">Dati Segnalatore</p>

    <div class="form-group">
        <label for="name" class="col-sm-3 control-label form-label-aligned m-b-20">Nome</label>
        <div class="col-sm-9 field-column m-b-20">
            <div class="prepend-icon">
                <input type="text"
                       id="name"
                       name="name"
                       class="form-control"
                       [class.input-error]="nameError"
                       placeholder="Inserisci il nome"
                       autocomplete="off"
                       [(ngModel)]="referrer.Name">
                <i class="icon-user"></i>
            </div>
            <span class="field-error" *ngIf="nameError">{{ nameError }}</span>
        </div>
    </div>

    <div class="form-group">
        <label for="surname" class="col-sm-3 control-label form-label-aligned m-b-20">Cognome</label>
        <div class="col-sm-9 field-column m-b-20">
            <div class="prepend-icon">
                <input type="text"
                       id="surname"
                       name="surname"
                       class="form-control"
                       [class.input-error]="surnameError"
                       placeholder="Inserisci il cognome"
                       autocomplete="off"
                       [(ngModel)]="referrer.Surname">
                <i class="icon-user"></i>
            </div>
            <span class="field-error" *ngIf="surnameError">{{ surnameError }}</span>
        </div>
    </div>

    <div class="form-group">
        <label for="email" class="col-sm-3 control-label form-label-aligned m-b-20">Email</label>
        <div class="col-sm-9 field-column m-b-20">
            <div class="prepend-icon">
                <input type="email"
                       id="email"
                       name="email"
                       class="form-control"
                       [class.input-error]="emailError"
                       placeholder="Inserisci indirizzo email"
                       autocomplete="off"
                       [(ngModel)]="referrer.Email">
                <i class="icon-envelope"></i>
            </div>
            <span class="field-error" *ngIf="emailError">{{ emailError }}</span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-blue btn-embossed" (click)="createReferrer()">Crea</button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
